import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { HaHelpVideoServiceService } from '../../services/HaHelpVideo.service';
import { ErrorModel } from '../../../../shared/models/Error.model';
declare var $: any;

@Component({
  selector: 'app-ha-help-video',
  templateUrl: './ha-help-video.component.html',
  styleUrls: ['./ha-help-video.component.css']
})

export class HaHelpVideoComponent implements OnInit {
  showOverlayHelpVideo: boolean = false;
  helpVideoLink: string = '';
  helpVideoCategory: string = '';
  helpVideoCategoryParent: number = 0;
  helpVideoTitle: string = '';
  helpVideoShortDescription: string = '';
  allCategories: any[];
  OrganiseAllCategories: any[];
  allVideos: any[];
  searchTermVideoHa: string = '';
  mainViewError = new ErrorModel();
  constructor(private _service: HaHelpVideoServiceService, private _sanitizer: DomSanitizer) {}

  ngOnInit() {
    this.allCategories = [];
    this.OrganiseAllCategories = [];
    this.getAllVideosNCategories();
  }

  getAllVideosNCategories() {
    this.showOverlayHelpVideo = true;
    this.mainViewError.display = false;
    this._service.getAllVideosNCategories().subscribe(
    (data: any[]) => {

      this.allCategories = data['videoNCategories'];
      this.OrganiseAllCategories = data['videoNCategories'];
      this.OrganiseAllCategories.forEach(element => {
        element['videos'].forEach(element1 => {
          this.addUrl(element1);

        });
      });
      this.allCategories.forEach(element => {
        element['videos'].forEach(element1 => {
          this.addUrl(element1);

        });
      });
    },
    (error) => {
      this.mainViewError.error = error;
      this.mainViewError.display = true;

    }).add(() => {
      this.showOverlayHelpVideo = false;
    });
  }


  addUrl(element) {
    const url = this._sanitizer.bypassSecurityTrustResourceUrl(element.url) as string;
    element.urlShow = url;

  }

  getFilteredList(selectedHelpPc) {
    if (selectedHelpPc == '-') {
      this.allCategories = this.OrganiseAllCategories;
    } else {
      this.allCategories = this.OrganiseAllCategories.filter(category => category.id == selectedHelpPc);
    }
  }
}
